import _ from "lodash";
import { saveAs } from "file-saver";

import scraperApi from "api";

import { domainReportFileName } from "utils/chartsUtils";

import { CountersData } from "pages/dashboard/PlanOverviewAndStatsCard";
import { ChartsData } from "pages/dashboard/UsageHistoryCharts";
import { ChangeLogData } from "pages/dashboard/WhatsNewCard";

import { RouteErrors } from "routes/data-routes/types";
import OkResponse from "./OkResponse";
import throwIfCanceled from "./throwIfCanceled";


export async function changelogLoader({ request }: { request: Request }): Promise<ChangeLogData | RouteErrors.RouterActionError> {
  try {
    const mostRecentChangelogEntries = await scraperApi.status.changelog(3, { signal: request.signal });
    return mostRecentChangelogEntries;
  } catch (err) {
    throwIfCanceled(err);

    return {
      error: {
        message: (err as Error).message
      }
    };
  }
}


export async function usageHistoryLoader({ request }: { request: Request }): Promise<{ updatedAt: Date, data: ChartsData[], counters: CountersData } | RouteErrors.RouterActionError> {
  try {
    const searchParams = new URL(request.url).searchParams;
    const domainsFilter = _.union(searchParams.getAll("domains[value]"), searchParams.getAll("domains"));
    const intervalFilter = searchParams.get("interval[value][interval]") || "30";
    const resolutionAmount = searchParams.get("interval[value][resolution][amount]") || "1";
    const resolutionUnit = searchParams.get("interval[value][resolution][unit]") || "day";

    const data: ChartsData[] = await scraperApi.stats.usageHistory(
      new URLSearchParams({ domains: domainsFilter.join(","), interval: intervalFilter, "resolution-amount": resolutionAmount, "resolution-unit": resolutionUnit }),
      { signal: request.signal }
    );

    // TODO:
    //  - aggregate data based on the domain filters (still not sure how to do that if the user picked multiple domains... should we use stacked charts in that case?)

    // also return counters data here, that has to be refreshed when the charts are refreshed
    const counters = await scraperApi.stats.counters({ signal: request.signal });

    return {
      updatedAt: new Date(),
      data: data,
      counters: counters
    };
  } catch (err) {
    throwIfCanceled(err);

    return {
      error: {
        message: (err as Error).message,
      }
    };
  }
}

export async function downloadPerDomainReportLoader(): Promise<Response | RouteErrors.RouterActionError> {
  try {
    const perDomainReport = await scraperApi.stats.perDomainReport({ source: "clickhouse" });
    const blob = new Blob([ perDomainReport ], { type: "text/csv;charset=utf-8" });
    saveAs(blob, domainReportFileName());
    return new OkResponse();
  } catch (err) {
    throwIfCanceled(err);

    return {
      error: {
        message: "There was an error generating the per-domain report. Please try again later or contact our support team for help."
      }
    };
  }
}
